import { ComboModel } from '../components/combo/combo-model';
import { RedoneStatus } from '../enums/redone-status.enum';
import { SortHelper } from '../helpers/sort-helper';

export class RedoneStatusHelper {
  public static buildOptions(): ComboModel[] {
    const options = new Array<ComboModel>();

    const comboNoReason = this.convertToComboModel(RedoneStatus.NoReason)!;
    comboNoReason.displayOrder = 0;
    comboNoReason.label = `(${this.getKeyShorcut(RedoneStatus.NoReason)!.toUpperCase()}) ${comboNoReason.label} `;
    options.push(comboNoReason);

    const comboManufacturingDefect = this.convertToComboModel(RedoneStatus.ManufacturingDefect)!;
    comboManufacturingDefect.displayOrder = 1;
    comboManufacturingDefect.label = `(${this.getKeyShorcut(RedoneStatus.ManufacturingDefect)!.toUpperCase()}) ${
      comboManufacturingDefect.label
    }`;
    options.push(comboManufacturingDefect);

    const comboShadeError = this.convertToComboModel(RedoneStatus.ShadeMissmatchDefect)!;
    comboShadeError.displayOrder = 2;
    comboShadeError.label = `(${this.getKeyShorcut(RedoneStatus.ShadeMissmatchDefect)!.toUpperCase()}) ${comboShadeError.label} `;
    options.push(comboShadeError);

    const comboImpressionDefect = this.convertToComboModel(RedoneStatus.ImpressionDefect)!;
    comboImpressionDefect.displayOrder = 3;
    comboImpressionDefect.label = `(${this.getKeyShorcut(RedoneStatus.ImpressionDefect)!.toUpperCase()}) ${comboImpressionDefect.label}`;
    options.push(comboImpressionDefect);

    const comboFittingDefect = this.convertToComboModel(RedoneStatus.FittingDefect)!;
    comboFittingDefect.displayOrder = 4;
    comboFittingDefect.label = `(${this.getKeyShorcut(RedoneStatus.FittingDefect)!.toUpperCase()}) ${comboFittingDefect.label}`;
    options.push(comboFittingDefect);

    const comboProtocolComplianceDefect = this.convertToComboModel(RedoneStatus.ProtocolComplianceDefect)!;
    comboProtocolComplianceDefect.displayOrder = 5;
    comboProtocolComplianceDefect.label = `(${this.getKeyShorcut(RedoneStatus.ProtocolComplianceDefect)!.toUpperCase()}) ${
      comboProtocolComplianceDefect.label
    }`;
    options.push(comboProtocolComplianceDefect);

    const comboOcclusionDefect = this.convertToComboModel(RedoneStatus.OcclusionDefect)!;
    comboOcclusionDefect.displayOrder = 6;
    comboOcclusionDefect.label = `(${this.getKeyShorcut(RedoneStatus.OcclusionDefect)!.toUpperCase()}) ${comboOcclusionDefect.label}`;
    options.push(comboOcclusionDefect);

    const comboProsthesisLoss = this.convertToComboModel(RedoneStatus.ProsthesisLoss)!;
    comboProsthesisLoss.displayOrder = 7;
    comboProsthesisLoss.label = `(${this.getKeyShorcut(RedoneStatus.ProsthesisLoss)!.toUpperCase()}) ${comboProsthesisLoss.label}`;
    options.push(comboProsthesisLoss);

    options.sort(SortHelper.sortByDisplayOrder);
    return options;
  }

  public static convertKeyboardEvent(event: KeyboardEvent): RedoneStatus | undefined {
    if (event?.key) {
      if (event.key === this.getKeyShorcut(RedoneStatus.NoReason)) {
        return RedoneStatus.NoReason;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.ManufacturingDefect)) {
        return RedoneStatus.ManufacturingDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.ShadeMissmatchDefect)) {
        return RedoneStatus.ShadeMissmatchDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.ImpressionDefect)) {
        return RedoneStatus.ImpressionDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.FittingDefect)) {
        return RedoneStatus.FittingDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.ProtocolComplianceDefect)) {
        return RedoneStatus.ProtocolComplianceDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.OcclusionDefect)) {
        return RedoneStatus.OcclusionDefect;
      } else if (event.key === this.getKeyShorcut(RedoneStatus.ProsthesisLoss)) {
        return RedoneStatus.ProsthesisLoss;
      }
    }
    return undefined;
  }

  public static convertToComboModel(enumValue: RedoneStatus): ComboModel | null {
    if (Object.values(RedoneStatus).includes(enumValue)) {
      const comboModel = new ComboModel();
      comboModel.key = enumValue.valueOf().toString();
      comboModel.label = this.translateEnum(enumValue);
      return comboModel;
    } else {
      return null;
    }
  }

  public static convertToEnum(comboModel: ComboModel): RedoneStatus | undefined {
    if (comboModel) {
      if (comboModel.key === RedoneStatus.FittingDefect.valueOf().toString()) {
        return RedoneStatus.FittingDefect;
      } else if (comboModel.key === RedoneStatus.ManufacturingDefect.valueOf().toString()) {
        return RedoneStatus.ManufacturingDefect;
      } else if (comboModel.key === RedoneStatus.NoReason.valueOf().toString()) {
        return RedoneStatus.NoReason;
      } else if (comboModel.key === RedoneStatus.OcclusionDefect.valueOf().toString()) {
        return RedoneStatus.OcclusionDefect;
      } else if (comboModel.key === RedoneStatus.ImpressionDefect.valueOf().toString()) {
        return RedoneStatus.ImpressionDefect;
      } else if (comboModel.key === RedoneStatus.ProtocolComplianceDefect.valueOf().toString()) {
        return RedoneStatus.ProtocolComplianceDefect;
      } else if (comboModel.key === RedoneStatus.ProsthesisLoss.valueOf().toString()) {
        return RedoneStatus.ProsthesisLoss;
      } else if (comboModel.key === RedoneStatus.ShadeMissmatchDefect.valueOf().toString()) {
        return RedoneStatus.ShadeMissmatchDefect;
      }
    }
    return undefined;
  }

  public static getKeyShorcut(redoneStatus: RedoneStatus): string | undefined {
    switch (redoneStatus) {
      case RedoneStatus.NoReason:
        return 'a';
      case RedoneStatus.ManufacturingDefect:
        return 'b';
      case RedoneStatus.ShadeMissmatchDefect:
        return 'c';
      case RedoneStatus.ImpressionDefect:
        return 'd';
      case RedoneStatus.FittingDefect:
        return 'e';
      case RedoneStatus.ProtocolComplianceDefect:
        return 'f';
      case RedoneStatus.OcclusionDefect:
        return 'g';
      case RedoneStatus.ProsthesisLoss:
        return 'h';
      default:
        return undefined;
    }
  }

  public static translateEnum(enumValue: RedoneStatus): string | undefined {
    if (enumValue === RedoneStatus.NoReason) {
      return 'Sans justification';
    } else if (enumValue === RedoneStatus.ManufacturingDefect) {
      return 'Défaut de fabrication';
    } else if (enumValue === RedoneStatus.ImpressionDefect) {
      return "Défaut d'empreintes";
    } else if (enumValue === RedoneStatus.FittingDefect) {
      return "Défaut d'essayage";
    } else if (enumValue === RedoneStatus.ProsthesisLoss) {
      return 'Perte de prothèse';
    } else if (enumValue === RedoneStatus.ProtocolComplianceDefect) {
      return 'Non respect du protocole';
    } else if (enumValue === RedoneStatus.OcclusionDefect) {
      return "Problème d'occlusions";
    } else if (enumValue === RedoneStatus.ShadeMissmatchDefect) {
      return 'Erreur de teinte';
    }
    return undefined;
  }
}
